<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      ref="resource"
      title="Tournées"
      bdTable="routes"
      :actions="actions"
      :fields="fields"
      :parameters="{
        admin: $store.getters.isNegotiator ? false : $props.admin,
        archive: $props.archive,
        month: dateTable.date.value
      }"
      :Api="Api"
    >
      <template v-slot:menu>
        <label class="mx-3 align-self-center">Type : </label>
        <mh-input
          @change="submitSearch()"
          append="🔍"
          field="date"
          :table="dateTable"
        >
        </mh-input>
      </template>
    </bd-table-list>
    <b-modal size="xl" id="google-route" hide-footer>
      <template #modal-title>Tournée négociateur</template>
      <GoogleRoute :data="googleData"></GoogleRoute>
    </b-modal>
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import gestion from "@/services/gestion.js";
import GoogleRoute from "@/components/GoogleRoute";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "RoutesList",
  components: {
    BdTableList,
    GoogleRoute,
    MhInput,
  },
  props: {
    admin: {
      type: Boolean,
      default: true,
    },
    archive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      Api: gestion.routes,
      googleData: null,
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Tournées",
          active: true,
        },
      ],
      actions: [
        {
          label: "Voir la tournée",
          icon: "pencil-square",
          variant: "success",
          action: (id) => this.viewRoute({ ID: id }),
        },
        {
          label: "Supprimer la tournée",
          icon: "x-circle-fill",
          variant: "danger",
          condition: () => this.$store.getters.isSuperAdmin,
          action: (id) => this.deleteRoute({ ID: id }),
        },
      ],
      dateTable: {
        date: {
          label: "",
          type: "enum",
          value: "all",
          options: [
            {
              value: "all",
              text: "Toutes les tournées",
            },
          ],
        },
      },
      fields: [
        {
          key: "ID",
          label: "#",
          sortable: true,
          class: "text-center",
          thStyle: { width: "100px" },
        },
        {
          key: "creation_date",
          label: "Date",
          sortable: true,
          thStyle: { width: "200px" },
          formatter: (value) => this.toDate(value),
        },

        {
          key: "nego",
          label: "Négociateur",
          sortable: true,
          class: "text-truncate",
        },

        {
          key: "decoded",
          label: "Adresses",
          class: "text-truncate",
          sortable: true,
          formatter: (value, key, item) => {
            let a = "N/A";
            if (item.decoded.waypoints) {
              a = item.decoded.waypoints.join("</br>");
            } else if (item.decoded.error) {
              a = "<strong>" + item.decoded.error.status + "</strong>";
            }
            return a;
          },
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "text-center",
        },
      ],
    };
  },
  created() {
    const t= new Date();
    let actualMonth = t.getMonth();
    let actualYear = t.getFullYear();
    let startYear = 2022;
    let startMonth = 9; 
    let cont = true;
    while(cont) {
      this.dateTable.date.options.push({
        value: actualYear + '-' + (actualMonth + 1),
        text: DateTime.months.fr[actualMonth] + ' ' + actualYear
      })
      if(startYear == actualYear && startMonth == actualMonth) {
        cont = false;
      }
      actualMonth--;
      if(actualMonth < 0) {
        actualMonth = 11;
        actualYear--;
      }
    }
  },
  methods: {
    viewRoute(e) {
      let x = this.$refs.resource.rows.filter((el) => el.ID == e.ID);
      if (x.length) {
        this.googleData = x[0].decoded;
        this.googleData.id = e.ID;
        this.$bvModal.show("google-route");
      }
    },
    deleteRoute(e) {
      this.$bvModal
        .msgBoxConfirm("Êtes-vous sûr de vouloir supprimer cette tournée?", {
          title: "Demande de confirmation",
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Oui",
          cancelTitle: "Annuler",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            gestion.routes.suppress(e.ID).then((response) => {
              if (response.data.success) {
                this.$bvToast.toast("Tournée supprimée", {
                  title: `Recuperator`,
                  toaster: "b-toaster-top-right",
                  variant: "success",
                  autoHideDelay: 2000,
                  solid: false,
                });
                this.$refs.resource.submitSearch(false);
              }
            });
          }
        });
    },
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDateTime(d);
    },
    submitSearch() {
      this.$refs.resource.submitSearch(false)
    }
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>